import {createApiClient} from "./index";
import {generateQueryParams} from "helpers/common";
import {MobilePushDto, MobilePushQueryParams} from "types/mobilePush";

export const mobilePushApi = {
    async getMobilePush({
                            filters,
                            token,
                            params,
                            apiKey
                        }: MobilePushQueryParams, signal?: AbortSignal): Promise<MobilePushDto> {
        const api = createApiClient(apiKey);

        const data = Object.fromEntries(
            Object.entries(filters).filter(([_, value]) => !!value || value === 0)
        );

        const queryParams = generateQueryParams(params);

        const response = await api.post(`/mobile-push/filter${queryParams}`, {
            ...data,

        }, {
            headers: {
                Authorization: `Bearer ${token}`,
            },
            signal,
        });
        return response.data;
    },
};
